import { Identifier, ReduxState } from 'react-admin';
import { MetadataAvatarType } from '../../utils/types';
import { CustomReducerState } from './index';
import { ACTIONS, selectIncidentType, SelectIncidentTypeAction } from '../actions/incidentTypes';
import { METADATA_AVATAR_TYPES } from '../../providers/resources';
import { clearTicketingStateCreator } from '../actions/ticketingState';

export interface IncidentTypeState {
    selected: {
        [key: Identifier]: MetadataAvatarType;
    };
}

const InitialState: IncidentTypeState = {
    selected: {},
};

export const getIncidentTypeSelected = (state: CustomReducerState & ReduxState): MetadataAvatarType | undefined => {
    const selected = state.ticketing.incidentTypes.selected;
    const selectedUriKey = selected ? Object.keys(selected) : [];
    if (
        selected &&
        selectedUriKey.length > 0 &&
        state.admin.resources[METADATA_AVATAR_TYPES].list.ids.includes(selectedUriKey[0])
    ) {
        return state.admin.resources[METADATA_AVATAR_TYPES].data[selectedUriKey[0]] as MetadataAvatarType;
    }
    return undefined;
};

const reducer = (state: IncidentTypeState = InitialState, action: ACTIONS) => {
    switch (action.type) {
        case selectIncidentType.action: {
            const iAction: SelectIncidentTypeAction = action;
            const newRecord = iAction.payload.record
                ? {
                      // @ts-ignore
                      [iAction.payload.record.id]: {
                          ...iAction.payload.record,
                      },
                  }
                : {};

            return {
                ...state,
                selected: {
                    ...newRecord,
                },
            };
        }
        case clearTicketingStateCreator.action: {
            return {
                ...InitialState,
            };
        }
        default:
            return state;
    }
};

export default reducer;
